import { type ButtonProps } from "@faire/web/slate/Button";
import { cn } from "@faire/web/tools/cn";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";

interface RSCButtonProps {
  linkTo?: string;
  onClick: (e: React.MouseEvent) => void;
  variant?: ButtonProps["variant"];
  style?: ButtonProps["style"];
  disabled?: ButtonProps["disabled"];
  loading?: ButtonProps["loading"];
  dataTestId?: string;
  children: React.ReactNode;
}
export const RSCButton: React.FC<RSCButtonProps> = (props) => {
  const disabled = props.disabled || props.loading;

  const commonClassNames = cn(
    "relative flex items-center justify-center",
    "text-[14px]/[20px] font-extralight tracking-[0.15px]",
    "lining-nums tabular-nums",
    "m-0 px-[23px] py-0",
    "h-[48px] w-auto",
    "cursor-pointer",
    "border-core-border-default border border-solid",
    "f_t_paragraphSansRegular",
    disabled
      ? [
          "bg-core-surface-subdued text-core-text-subdued border-core-border-muted",
        ]
      : null,
    !disabled && props.variant === "primary"
      ? [
          "bg-core-surface-default text-core-text-inverse",
          "hover:bg-core-surface-hover hover:border-core-border-hover",
        ]
      : null,
    !disabled && props.variant === "secondary"
      ? [
          "bg-core-surface-inverse text-core-text-default",
          "hover:bg-core-surface-hover hover:text-core-text-inverse",
        ]
      : null
  );

  if (props.linkTo) {
    return (
      <Link
        to={props.linkTo}
        onClick={props.onClick}
        data-test-id={props.dataTestId}
        className={commonClassNames}
        style={props.style}
      >
        {props.children}
      </Link>
    );
  }

  return (
    <button
      onClick={props.onClick}
      data-test-id={props.dataTestId}
      className={commonClassNames}
      style={props.style}
      disabled={props.disabled}
      aria-disabled={props.disabled}
    >
      {props.children}
    </button>
  );
};
